import { Dayjs } from 'dayjs';
import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';
import { TimeZone } from '../../time/timezone.js';

export class NFCWritePayload extends DataModel {
  static readonly TYPE_ID: string = '9e29556849014ceaaed45ff4b80b5d62';

  private constructor(
    public readonly payload: string,
    public readonly creationDate: Dayjs,
  ) {
    super();
  }

  get $typeId(): string {
    return NFCWritePayload.TYPE_ID;
  }

  static create(args: {
    payload: string,
    creationDate: Dayjs,
  }): NFCWritePayload {
    return new NFCWritePayload(
        args.payload,
        args.creationDate,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): NFCWritePayload {
    return NFCWritePayload.create({
      payload: MapUtils.getString(map, 'payload'),
      creationDate: context.decodeDate(MapUtils.getNumber(map, 'creationDate')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'payload': this.payload,
      'creationDate': context.encodeDate(this.creationDate),
    };
  }

  clone(): this {
    return NFCWritePayload.create({
      payload: this.payload,
      creationDate: TimeZone.cloneDate(this.creationDate),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.payload === this.payload &&
        other.creationDate === this.creationDate;
  }
}

export class NFCWritePayloadBuilder extends DataModelBuilder<NFCWritePayload> {
  build(context: SerializationContext, map: SerializedData): NFCWritePayload {
    return NFCWritePayload.fromMap(context, map);
  }
}
